import React, { Component } from 'react';
import _ from 'lodash';
import dayjs from 'dayjs';
import { Button, Form, Select, Tooltip, DatePicker } from 'antd';
import SelectOrder from '@/components/SelectOrder';
import styles from './tenant_transactions.module.scss';
import { tenantsTransactionTypes } from '@/containers/finances/constants';
import * as apis from '@/apis';

const { RangePicker } = DatePicker;
const transactionTypeKeys = Object.keys(tenantsTransactionTypes);
const formItemLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

@Form.create({
  onValuesChange: (props, changedValues, values) => {
    if (values.time_range && values.time_range[0] && values.time_range[1]) {
      values.time_range = [
        values.time_range[0].startOf('day').valueOf(),
        values.time_range[1].endOf('day').valueOf(),
      ];
    } else {
      delete values.time_range;
    }

    values = _.pickBy(values, _.identity);

    props.onChange(values);
  },
})
export default class Filters extends Component {
  render() {
    const { getFieldDecorator } = this.props.form;
    const { query = {} } = this.props;
    const downloadUrl = apis.downloadTransactionsUrl(query);

    return (
      <Form onSubmit={this.handleSubmit} layout="inline">
        <div className={styles.filters}>
          <Form.Item
            className={styles.row}
            {...formItemLayout}
            label="交易类型"
          >
            {getFieldDecorator('type', {
              initialValue: query.type || null,
            })(
              <Select placeholder="请选择交易类型" style={{ width: 200 }}>
                <Select.Option value={null}>全部</Select.Option>
                {transactionTypeKeys.map((key) => (
                  <Select.Option key={key} value={key}>
                    {tenantsTransactionTypes[key]}
                  </Select.Option>
                ))}
              </Select>
            )}
          </Form.Item>
          <Form.Item className={styles.row}
            {...formItemLayout} label="工单">
            {getFieldDecorator('order', {
              normalize: this.normalizeOrder,
              initialValue: query.order || null,
            })(<SelectOrder style={{ width: 180 }} placeholder="输入工单号" />)}
          </Form.Item>
          <Form.Item
            className={styles.row}
            {...formItemLayout}
            label="日期范围"
          >
            {getFieldDecorator('time_range', {
              initialValue: query.time_range
                ? [dayjs(+query.time_range[0]), dayjs(+query.time_range[1])]
                : [0, 0],
            })(<RangePicker />)}
          </Form.Item>
          <Form.Item className={styles.row} {...formItemLayout}>
            <div className={styles.submitBtns}>
              <Tooltip title="注意：将下载当前查询条件内所有数据（无需再次按页下载）">
                <Button type="link" size="small" href={downloadUrl}>
                  下载所有数据
                </Button>
              </Tooltip>
            </div>
          </Form.Item>
        </div>
      </Form>
    );
  }
}
